var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip-decorator"},[_c('div',{staticClass:"tooltip-decorator__tooltip"},[_c('tooltip',[_c('div',{staticClass:"max-w-xs"},[_vm._v(" "+_vm._s(_vm.content)+" ")])])],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }